export function capitalize(value: string) {
    if (value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }

    return '';
}
